export const formatterNumberDecimals = (valor, decimales) => {
  let formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales,
  });
  return formatter.format(valor);
};

export const divideAndCeil = (numerator, denominator) => {
  if (denominator === 0) {
    throw new Error("Division by zero is not allowed");
  }
  return Math.ceil(numerator / denominator);
};
